module.exports = "/images/admin_warning.svg?eae54180f70c34ff3bde48eb5f9865bb";